import React from 'react'
// import { LazyLoad } from '../../common/Functions'

function Ecosystem() {
  return (
  <section className="max-w-screen-xl	mx-auto text-center">
    <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
      <div className="w-full flex flex-col justify-center items-center">
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            About the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            Nickel Asia Corporation (NAC) is the Philippines' largest producer of lateritic nickel ore and one of the largest in the world. Cagdianao Mining Corporation is a subsidiary company of Nickel Asia Corp. Cagdianao mine site is in the municipality of Cagdianao, at the Northeastern side of the province of Dinagat Islands. Its area of operations is within the Surigao Mineral Reservation. CMC exports saprolite and limonite ore. Back in 2017, the R&D team of CMC is looking for a crew that can develop a web portal that can capture vast amounts of data that is easy to use for their encoders in the mine site. Ore transport, equipment usage, operator hours, and many more all had to be tracked. Every day, their encoders contended with mountains of data to capture, that traditional pen-and-paper and even Excel sheets struggled to deal with all of them. 
          </p>
          <p className="text-left text-lg text-gray-600 mt-5">
            Our team regularly met with the NAC members to find out their needs, and we made suggestions on how to optimize the processes. We designed a customizable web portal for efficient organization. Our product allowed them not only to conveniently fill-out forms but also automatically generate reports based on filter parameters. We included automated formulas on the generated data reports as well. We are sure to have satisfied our clients with our product, as our partnership with NAC is continuously working for future projects.
          </p>
        </div>
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            My Role in the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            I started as the sole UI/UX designer creating the initial web mockups and contributes to front-end development as well. As the project continuously for new contracts, I promoted as the Project Manager that directly communicate with the NAC R&D team concerns and requests, including managing the job assignments, project deliverables, and accomplishment reports. I also provided documentation such as user manuals for the users of the system and technical documents of database structure, data flow diagram, and process flowcharts.
          </p>
        </div>
        {/*
          <em className="text-gray-400 mb-10">CMC-OMT Web App Mock-ups</em>
          <LazyLoad src={require('../../common/images/nac/web-mockup.png')} alt="NAC Web Mockup"/>
        */}
      </div>
    </div>
  </section>
  )
}

export default Ecosystem
